import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import React from 'react';

export const parentescoArray = [
  { id: 'MADRE', text: 'MADRE' },
  { id: 'PADRE', text: 'PADRE' },
  { id: 'HERMANO', text: 'HERMANO' },
  { id: 'TIO', text: 'TIO' },
  { id: 'ABUELO', text: 'ABUELO' },
  { id: 'MAYOR_EDAD', text: 'MAYOR DE EDAD' },
];

const TiposParentescosField = ({
  value,
  onChange,
  isLabel = false,
  isAll = true,
  variant = 'standard',
  fullWidth = false,
}) => {
  return (
    <FormControl size="small" fullWidth={fullWidth} variant={variant}>
      {isLabel && (
        <InputLabel id="update-estatus-recibo-label">
          Estatus de recibo
        </InputLabel>
      )}
      <Select
        variant={variant} // "filled" - "standard" - "outlined"
        labelId="update-estatus-recibo-label"
        id="update-estatus-recibo"
        value={value}
        size="small"
        onChange={(e) => {
          onChange(e.target.value);
        }}
        label="Estatus del recibo"
      >
        {isAll && <MenuItem value={null}>TODOS</MenuItem>}
        {parentescoArray.map((el) => {
          return <MenuItem value={el.id}>{el.text}</MenuItem>;
        })}
      </Select>
    </FormControl>
  );
};

export default TiposParentescosField;
